<template>
  <v-dialog v-model="disqualifyPrompt" max-width="650px" persistent transition="dialog-bottom-transition">
    <v-card elevation="10" class="premium-card">
      <!-- Header -->
      <div class="header-gradient py-4 px-6">
        <div class="d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-avatar size="42" color="rgba(255,255,255,0.15)" class="mr-3">
              <v-icon color="white">mdi-account-check</v-icon>
            </v-avatar>
            <div>
              <h3 class="header-title mb-1">{{ pageDescription }}</h3>
              <p class="header-subtitle mb-0">
                Verify the age proof document for this nomination
              </p>
            </div>
          </div>

          <div class="header-bar"></div>

          <v-btn icon class="close-btn" @click="closePrompt" :loading="closeLoading">
            <v-icon v-if="!closeLoading">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Content -->
      <v-card-text class="pa-6">
        <!-- Candidate Info -->
        <div class="candidate-info mb-5" v-if="row">
          <div class="d-flex align-center mb-3">
            <div class="section-icon-wrapper mr-3">
              <v-icon size="20" color="deep-purple darken-2"
                >mdi-account-details</v-icon
              >
            </div>
            <h3 class="font-weight-medium text-subtitle-1">
              Candidate Information
            </h3>
          </div>
          <div class="section-divider mb-3"></div>

          <div class="candidate-data px-3">
            <div class="d-flex align-center mb-2">
              <span class="data-label">Name:</span>
              <span class="data-value font-weight-medium">{{
                row.MemberName || "Not Available"
              }}</span>
            </div>
            <div class="d-flex align-center">
              <span class="data-label">LO:</span>
              <span class="data-value font-weight-medium">{{
                row.LomName || "Not Available"
              }}</span>
            </div>
          </div>
        </div>

        <!-- Qualification Description -->
        <div
          v-if="row && row.QualificationDescription"
          class="qualification-desc-card mb-5"
        >
          <div class="d-flex align-center mb-2">
            <div class="desc-icon-wrapper mr-3">
              <v-icon size="22" color="deep-purple darken-2"
                >mdi-file-document-edit</v-icon
              >
            </div>
            <h3 class="font-weight-medium text-subtitle-1 mb-0">
              Qualification Description
            </h3>
          </div>
          <div class="desc-divider mb-2"></div>
          <div class="desc-content px-3 py-2">
            <span class="desc-text">{{
              stripHtml(row.QualificationDescription)
            }}</span>
          </div>
        </div>
      </v-card-text>

      <!-- Footer -->
      <v-divider class="mx-4"></v-divider>
      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>

        <v-btn
          color="grey darken-1"
          text
          class="px-4 mr-2 action-btn cancel-btn"
          @click="closePrompt"
          :loading="closeLoading"
        >
          <v-icon left size="18">mdi-close-circle</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid: true,
      ElectionOfficerFlag: false,
      records: {},
      disqualifyPrompt: true,
      closeLoading: false,
    };
  },
  methods: {
    closePrompt() {
      // small loading feedback on close
      this.closeLoading = true;
      setTimeout(() => {
        console.log("closePrompt called");
        this.closeLoading = false;
        this.$emit("hideDialog", this.ResultFlag);
      }, 220);
    },
    refreshPageData() {},
    stripHtml(html) {
      if (!html) return "";
      return html.replace(/<[^>]*>/g, "");
    },
  },
  mounted() {
    this.refreshPageData();
    const roleId = this.$session.get("RoleId") || "";
    this.RoleId = roleId;

    const ElectionOfficerFlag = this.$session.get("ElectionOfficerFlag") || "";
    this.ElectionOfficerFlag = ElectionOfficerFlag;
  },
};
</script>

<style scoped>
.premium-card {
  border-radius: 12px;
  overflow: hidden;
}
.header-gradient {
  background: linear-gradient(90deg, #5b6ee1, #3fa7ff);
  color: #fff;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.header-title {
  margin: 0;
  font-weight: 700;
}
.header-subtitle {
  margin: 0;
  opacity: 0.95;
  font-size: 0.85rem;
}
.section-divider,
.desc-divider {
  height: 1px;
  background: rgba(0,0,0,0.06);
}
.qualification-desc-card,
.candidate-info {
  background: #fbfdff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(63,81,181,0.04);
}
.action-btn.cancel-btn {
  color: #37474f;
}
.close-btn {
  color: rgba(255,255,255,0.9);
}
</style>
